// extracted by mini-css-extract-plugin
module.exports = {"addToCalendar":"AddToCalendar_addToCalendar__7wmOm","link":"AddToCalendar_link__it1VR"};